



















import { Component, Vue, Prop } from 'vue-property-decorator';
import BreadCrumbs, { Breadcrumb } from './BreadCrumbs.vue';

@Component({
  components: { BreadCrumbs }
})
export default class ContentWrapper extends Vue {
  @Prop({ default: 'center' })
  public readonly headerAlign!: string;

  @Prop(Array)
  public readonly breadcrumbs!: Breadcrumb[];

  isLastBreadCrumb(i: number) {
    return i === this.breadcrumbs.length - 1;
  }
}
